import { render, staticRenderFns } from "./TraxAccountUserEditData.vue?vue&type=template&id=424cdad5"
import script from "./TraxAccountUserEditData.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserEditData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports